/**
 * The `default` of an exhaustive `switch` over a union (coding-standards §3.4): typed `never`, so a
 * new member without its own `case` is a compile error rather than a silent fall-through. Throws if
 * a value the types rule out arrives at run time anyway.
 *
 * The message names the variant only — a string, or an object's `state` / `kind` discriminant —
 * never the whole value: a view state can carry a page of users, and the message reaches the failure
 * screen and telemetry.
 */
export function assertNever(value: never): never {
    throw new Error(`Unhandled variant: ${describeVariant(value)}`);
}

function describeVariant(value: unknown): string {
    if (typeof value === 'string') {
        return JSON.stringify(value);
    }
    if (typeof value === 'object' && value !== null) {
        for (const key of ['state', 'kind', 'type'] as const) {
            const tag: unknown = (value as Record<string, unknown>)[key];
            if (typeof tag === 'string') {
                return `${key} ${JSON.stringify(tag)}`;
            }
        }
        return 'an object with no state, kind or type';
    }
    return typeof value;
}
